import React, { useState } from 'react';
import { Typography } from '@mui/material';
import CreateWarehouseBottomSheet from '@features/warehouses/components/create/CreateWarehouseBottomSheet';
import OnboardingOverlayCard from '../../shared/OnboardingOverlayCard';
import OnboardingEntityEmptyRow from '../../shared/OnboardingEntityEmptyRow';
import OnboardingSkipFooter from '../../shared/OnboardingSkipFooter';

interface WarehouseOnboardingCreateStepProps {
  onDismiss: () => void;
}

const WarehouseOnboardingCreateStep: React.FC<WarehouseOnboardingCreateStepProps> = ({
  onDismiss,
}) => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  return (
    <>
      <OnboardingOverlayCard
        title="Connect your first warehouse"
        footer={<OnboardingSkipFooter onDismiss={onDismiss} />}
      >
        <Typography variant="body2">
          Create a warehouse or connect one to keep your stock levels up to date.
        </Typography>

        <OnboardingEntityEmptyRow
          title="Add your first warehouse"
          actionLabel="Add warehouse"
          onAction={() => setIsCreateOpen(true)}
        />
      </OnboardingOverlayCard>

      <CreateWarehouseBottomSheet
        open={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
        syncUrl={false}
      />
    </>
  );
};

export default WarehouseOnboardingCreateStep;
